module.exports = __webpack_public_path__ + "static/media/share.823f2906.svg";